import { Box } from '@chakra-ui/react';

import { useBriefLiveWidgetState } from 'View/host-stream/components/brief-live-widget/state';

import GiveawayContent from './giveaway-content';
import PromoContent from './promo-content';
import TalkingPointContent from './talking-point-content';
import styles from './styles.module.css';

const BriefLiveWidgetListContent = () => {
  const { state } = useBriefLiveWidgetState();
  const { selectedTab } = state;

  const content = {
    'talking-point': <TalkingPointContent />,
    giveaway: <GiveawayContent />,
    promo: <PromoContent />,
  };

  return <Box className={styles['list-content__container']}>{content?.[selectedTab]}</Box>;
};

export default BriefLiveWidgetListContent;
